import React from 'react';
import Mtsc from './images/mtsc.svg';

const MENUS = [
  {
    id: 'home',
    name: '首页',
  },
  {
    id: 'products',
    name: 'CMC产品',
    showIcon: true,
    children: [
      { id: '/marketingcloud', name: 'Convertlab 营销云', type: 'parent' },
      { id: '/dmhub', name: 'DM Hub 营销自动化平台', iconId: 'dmhub' },
      { id: '/cdp', name: 'Data Hub 客户数据平台', iconId: 'datahub' },
      { id: '/adhub', name: 'Ad Hub 智能广告平台', iconId: 'adhub' },
      { id: '/cpm', name: 'CPM 同意与偏好管理平台', iconId: 'cpm' },
      { id: '/tahub', name: 'TA Hub 监测分析平台', iconId: 'tahub' },
      { id: '/pechub', noPage: true, name: 'PEC Hub 隐私计算平台', type: 'no-page', iconId: 'pechub' },
      { id: '/aihub', noPage: true, name: 'AI Hub 智能引擎', type: 'no-page', iconId: 'aihub' },
      { id: '/openhub', name: 'Open Hub 开放平台', iconId: 'openhub' },
      {
        id: 'https://www.huiju.cool',
        name: 'B2B荟聚数字营销云',
        target: '_blank',
        rel: 'noreferrer noopener',
        iconId: 'huiju',
      },
    ],
  },
  {
    id: 'scens',
    name: '营销应用场景',
    children: [
      { id: '/digitalmarketing', name: '数字化营销' },
      { id: '/privatetraffic', name: '私域流量运营' },
      { id: '/scrm', name: 'SCRM' },
      { id: '/campaign', name: '营销活动管理' },
      { id: '/royalty', name: '会员营销' },
      { id: '/personas', name: '用户画像' },
      { id: '/tags', name: '标签体系' },
    ],
  },
  {
    id: 'solutions',
    name: '行业方案',
    children: [
      { id: '/brandretail', name: '品牌零售行业解决方案' },
      { id: '/modernretail', name: '现代零售行业解决方案' },
      { id: '/fmcg', name: '快消行业解决方案' },
      { id: '/durables', name: '耐消行业解决方案' },
      { id: '/financial', name: '金融行业解决方案' },
      { id: '/b2b', name: 'B2B行业解决方案' },
    ],
  },
  {
    id: 'sources',
    name: '工具栈',
    children: [
      {
        id: 'http://martechwiki.convertlab.com',
        name: 'MarTech Wiki',
        target: '_blank',
        rel: 'noreferrer noopener nofollow',
      },
      {
        id: 'https://api-docs.convertlab.com/v2/restapi/overview',
        name: 'API文档',
        target: '_blank',
        rel: 'noreferrer noopener nofollow',
      },
      {
        id: 'https://www.convertlab.com/updateInfo',
        name: '产品更新',
        target: '_blank',
        rel: 'noreferrer noopener nofollow',
        // id: '/updateinfo',
        // name: '产品更新',
      },
      { id: '/yourtitles', name: '智能营销主题生成器' },
    ],
  },
  {
    id: 'blogs',
    name: '资讯中心',
    children: [
      { id: '/blogs', name: '洞察 | MarTech 增长笔记' },
      { id: '/ccmeaningful', name: '视频资源 | CC有料' },
      { id: '/whitepaper', name: '白皮书下载' },
    ],
  },
  {
    id: 'aboutus',
    name: '我们',
    children: [
      { id: '/about', name: '关于我们' },
      { id: '/about/#contacts', name: '联系我们' },
      {
        id: 'https://app.mokahr.com/apply/convertlab/7421#/',
        name: '加入我们',
        target: '_blank',
        rel: 'noreferrer noopener nofollow',
      },
      { id: '/partner', name: '合作伙伴' },
    ],
  },
  {
    id: 'summits',
    name: 'mtsc',
    nameImage: (
      <div className="mtsc-wrapper">
        <img src={Mtsc} alt="mtsc" className="mtsc-image" />
      </div>
    ),
  },
];

export default MENUS;
export { MENUS };
